import React from 'react';
import { Box, Typography } from '@mui/material';
import ClockIcon from './icons/ClockIcon';
import CalendarIcon from './icons/CalendarIcon';
import ClockAccentIcon from './icons/ClockAccentIcon';
import CalendarAccentIcon from './icons/CalendarAccentIcon';
import GptIcon from './icons/GptIcon';
import styles from './styles';

const getIcon = (theme) => {
  const icons = {
    time: ClockIcon,
    week: CalendarIcon,
    gpt: GptIcon,
  };

  const icons_accent = {
    time: ClockAccentIcon,
    week: CalendarAccentIcon,
    gpt: GptIcon,
  };

  switch (theme) {
    case 'dark':
      return icons_accent;
    default:
      return icons;
  }
};

const createIconComponent = (icon, theme) => {
  const Component = getIcon(theme)[icon];
  return (
    <Component
      sx={{
        width: { xs: '16px', lg: '24px' },
        height: { xs: '16px', lg: '24px' },
      }}
    />
  );
};

function Feature({ icon, title, theme }) {
  const textTheme = icon === 'gpt' ? 'orange' : theme;

  return (
    <Box component="p" sx={styles.featureItem}>
      <Box
        component="span"
        className={`icon_${theme}`}
        sx={{ ...styles.icon, ...styles[`icon_${theme}`] }}
      >
        {createIconComponent(icon, theme)}
      </Box>
      <Typography
        component="span"
        variant="desktopP2"
        sx={{ ...styles[`text_${textTheme}`] }}
      >
        {title}
      </Typography>
    </Box>
  );
}

export default Feature;
